import curry from 'lodash/curry';

var statesConfig = require('../../js/data/states-config.js');

// ====================================
//  Periodic Map
// ====================================

    const byPartyExceptions = curry((exceptionList, code) => {
        return exceptionList.indexOf(code) === -1;
    });

    function generateGeographicalStateMapping(party)
    {

        const demsOnly = ['DA', 'UN'];
        const repsOnly = ['UN'];

            /*
             * This is mirroring the layout on the page for easy reference when
             * making a change. If the actual layout of the map needs to be
             * changed (e.g. moving Alaska from the bottom of the map to the
             * top) then use the section entitled MAP LAYOUT in the periodic-map
             * sass file.
             */
            // const STATES = "                              ME|
            //                                            VT|NH|
            //                 WA|ID|MT|ND|MN|IL|WI|MI|NY|MA|RI|
            //                 OR|NV|WY|SD|IA|IN|OH|PA|NJ|CT|
            //                 CA|UT|CO|NE|MO|KY|WV|VA|MD|DE|
            //                    AZ|NM|KS|AR|TN|NC|SC|DC|
            //                          OK|LA|MS|AL|GA|
            //                 HI|AK|   TX|            FL|
            //                 GU|MP|AS|      DA|UN|      PR|VI";

            const STATES = ["ME", "VT", "NH", "WA", "ID", "MT", "ND", "MN", "IL", "WI", "MI", "NY", "MA", "RI", "OR",
                            "NV", "WY", "SD", "IA", "IN", "OH", "PA", "NJ", "CT", "CA", "UT", "CO", "NE", "MO", "KY",
                            "WV", "VA", "MD", "DE", "AZ", "NM", "KS", "AR", "TN", "NC", "SC", "DC", "OK", "LA", "MS",
                            "AL", "GA", "HI", "AK", "TX", "FL", "GU", "MP", "AS", "DA", "UN", "PR", "VI"];

            return STATES.map((code) => (code.trim()))
                         .filter(byPartyExceptions(party === 'Dem' ? repsOnly : demsOnly));
    }

    class PeriodicMap
    {
        constructor(p_element)
        {
            this.element = null;
            this.legend = [];
            this.tiles = [];

            if(p_element)
            {
                this.element = p_element;
                this.init();
            }
        }

        init()
        {
            this.createElements();
            this.build();
        }

        createElements()
        {
            this.mapContainer = this.element.find('.periodic-map--squares');
            this.legendContainer = this.element.find('.periodic-map--legend');
        }

        build()
        {
            this.buildTiles();
        }

        buildTiles()
        {
            // var checkDelegateCount = 0;

            $.each(generateGeographicalStateMapping("Dem"), $.proxy(function(id, val)
            {
                var newTile = $("<div class='periodic-map--square'></div>");
                var tileData = $.grep(statesConfig, function(e){ return e['short'] == val; })[0];
                
                var newTileObject = new PeriodicMap__Tile(newTile, tileData);

                // checkDelegateCount += parseInt(tileData['races'][0]['totalDelegates']);

                this.tiles.push( newTileObject );
                this.mapContainer.append( newTile );

            }, this));

            // console.log("Total added delegates: " + checkDelegateCount);
        }

        addCandidateToLegend( p_candidateName )
        {
            if(!(typeof p_candidateName === "string") || p_candidateName['lname'] !== undefined)
            {
                p_candidateName = p_candidateName['lname'].toLowerCase();
            }

            if(p_candidateName)
            {
                if(this.legendContainer.find(('.' + p_candidateName)).length === 0)
                {
                    var newLegendItem = $("<div class='periodic-map--legend__item " + p_candidateName + "' data-name='" + p_candidateName + "'>" + p_candidateName + "</div>");

                    this.legend.push(newLegendItem);
                    this.legend.sort(function(a, b) { return a.data('name') === "other" ? 1 : a.data('name') < b.data('name') ? -1 : a.data('name') > b.data('name') ? 1 : 0 } );
                    this.legendContainer.html(this.legend); 
                }
            }
        }

        getTileById(p_id)
        {
            return $.grep(this.tiles, function(e){ return e['id'] == p_id; })[0];
        }
    }

// ====================================
//  Periodic Map -- Tile
// ====================================

    class PeriodicMap__Tile
    {
        constructor(p_element, p_config)
        {
            this.baseClass = null;
            this.config = null;
            this.background = null;
            this.delegates = null;
            this._data = null;

            this.init(p_element, p_config)
        }

        init(p_element, p_config)
        {
            if(p_element && p_config)
            {
                this.config = p_config;
                this.element = p_element;

                this.build();
            }
        }

        build()
        {
            this.baseClass = this.element.attr('class');
            this.background = $("<div class='periodic-map--square__background'></div>");
            this.delegates = $("<p class='periodic-map--square__delegates'>0</p>");  // + this.config['races'][0]['totalDelegates'] + "</p>");

            var labels = $("<div class='periodic-map--square__labels'></div>");
                labels.append("<h5 class='periodic-map--square__state-name'>" + this.config['short'] + "</h5>");
                labels.append(this.delegates);

            this.background.append(labels);
            this.element.append(this.background);

            this.element.on('mouseover', $.proxy(this.onMouseOver, this));
            this.element.on('click', $.proxy(this.onTileClick, this));
        }

        buildOverlayContent()
        {
            var overlayContent = $("<div class='cnn-delegate-roll-call--overlay-content'></div>");
            var header = $("<div class='cnn-delegate-roll-call--overlay-content--header'></div>");
                header.append("<h6 class='cnn-delegate-roll-call--overlay-content--header__title'>" + this.config['long'] + "</h6>");
                header.append("<p class='cnn-delegate-roll-call--overlay-content--header__delegates'>" + this.config['races'][0]['totalDelegates'] + "</p>");

                overlayContent.append(header);

            var list = $("<ul class='cnn-delegate-roll-call--overlay-content--list'></ul>");
                
                $.each(this.data['candidates'], function(id, val)
                {
                    if(parseInt(val['rd']) !== 0)
                    {
                        

                        var candidate = getCandidateById(val['id']),
                            candidateName = candidate['lname'].toLowerCase(),

                            item = $("<li class='cnn-delegate-roll-call--overlay-content--list__item " + candidateName + " row'></li>"),
                            img = ("<div class='cnn-delegate-roll-call__image'><img class='cnn-delegate-roll-call__image__src' src='" + process.env.CDN + "media/images/" + (candidateName + '.' + (candidateName == 'other' ? 'png' : 'jpg')) + "' /></div>"),
                            title = ("<h4 class='cnn-delegate-roll-call__title'>" + candidateName + "</h4>"),
                            delegates = ("<p class='cnn-delegate-roll-call--overlay-content--list__item__rd' data-rd='" + parseInt(val['rd']) + "'>" + formatNumber(val['rd']) + "</p>");

                        var profile = $("<div class='col-xl-10 col-lg-10 col-md-8 col-sm-6 col-xs-3'>");
                        var result = $("<div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-1'>");
                            
                            profile.append(img);
                            profile.append(title);
                            result.append(delegates);

                            item.append(profile).append(result);

                        list.append(item);

                        if(id === 0)
                        {
                            overlayContent.addClass(candidateName);
                        }
                    }
                });

            var closebtn = $('<div class="cnn-delegate-roll-call--overlay__close-btn">close</div>');
                closebtn.one('click', function(e) { getOverlay().removeClass('show'); } );

                overlayContent.append(list);

                overlayContent.append(closebtn);

            return overlayContent;
        }

        update()
        {
            if(this.data)
            {
                var topCandidate = getCandidateById( this.data['candidates'][0]['id'] ),
                    topCandidateName = topCandidate['lname'].toLowerCase();

                if(parseInt(this.data['candidates'][0]['rd']) !== 0)
                {
                    this.element.attr( { "class" : this.baseClass + " voted " + topCandidateName } );
                    this.delegates.html(parseInt(this.data['candidates'][0]['rd']));
                }
                else
                {
                    this.element.attr( { "class" : this.baseClass });
                    this.delegates.empty();
                }
            }
            else
            {
                this.element.attr( { "class" : this.baseClass });
                this.delegates.empty();
            }
        }

        // --------------------------
        //  Events
        // --------------------------

        onMouseOver(e)
        {
            if(this.data)
            {
                var bp = getBreakpoint();

                if(bp !== "xs" && bp !== "sm")
                {
                    if(parseInt(this.data['candidates'][0]['rd']) !== 0)
                    {
                        var overlay = getOverlay(),
                            overlay_content = this.buildOverlayContent();
                            overlay.html(overlay_content);

                        $('html').on('mousemove', $.proxy(this.onMouseMove, this));
                        $(e.currentTarget).one('mouseout', $.proxy(this.onMouseOut, this));

                        overlay.addClass('show');
                    }
                }
            }
        }

        onMouseMove(e)
        {
            var overlay = getOverlay();
                overlay.css({ 'left' : e.pageX + 10, 'top' : (e.pageY - $('body').scrollTop() + 10) });
        }

        onMouseOut(e)
        {
            var overlay = getOverlay();
                overlay.removeClass('show');

                $('html').off('mousemove', $.proxy(this.onMouseMove, this));
        }

        onTileClick(e)
        {
            if(this.data)
            {
                var bp = getBreakpoint();

                if(bp === "xs" || bp === "sm")
                {
                    var overlay = getOverlay(),
                        overlay_content = this.buildOverlayContent();

                        overlay.attr({ "style" : "" });
                        overlay.html(overlay_content);
                        overlay.addClass('show');
                }
            }
        }

        // --------------------------
        //  Getters / Setters
        // --------------------------

        get data()
        {
            return this._data;
        }

        set data(p_data)
        {
            this._data = p_data;
            this.update();
        }

        get id()
        {
            return this.config !== null ? this.config["short"] : undefined;
        }
    }

// ====================================
//  Helper Functions
// ====================================

    function formatNumber(p_num)
    {
        return p_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function showFullResults()
    {
        return CNN.interactive.roll_call.showFullResults;
    }

    function getData()
    {
        return CNN.interactive.roll_call.data;
    }

    function getOverlay()
    {
        return CNN.interactive.roll_call.overlay;
    }

    function getCandidateById(p_id)
    {
        return CNN.interactive.roll_call.getCandidateById(p_id);
    }

    function getBreakpoint()
    {
        //  Return the responsive breakpoint.
        return window.getComputedStyle
                ? window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').split("\"").join("")
                : undefined;
    };

// ====================================
//  Exports
// ====================================

    exports.PeriodicMap = PeriodicMap;
    


/** WEBPACK FOOTER **
 ** ./src/js/mod/roll-call-mod--periodic-map.js
 **/